import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Blog from "../src/Pages/Blog/index";
import Layout from "./Layout";
import Category from "./Pages/Category/Category";
import Division from "./Pages/Category/Divison";
import Subcategory  from "./Pages/Category/Subcategory";
import Company from "./Pages/JobSection/Company";
import Events from "./Pages/Events/Events";
import Jobs from "./Pages/JobSection/Jobs";
import MarketPlace from "./Pages/MarketPlace/MarketPlace";
import Resources from "./Pages/Resources/Resources";
import TechTalks from "./Pages/TechTalks/TechTalks";
import JobsApplied from "./Pages/JobSection/JobApplied";
import Navbar from "./Pages/Navbar/Navbar";
import Abouts from "./Pages/Abouts/Abouts";
import Banner from "./Pages/Banner/Banner";
import Review from "./Pages/MarketPlace/Review";
import BrochureList from "./Pages/MarketPlace/BrochureList";
import ResourceDownloadList from "./Pages/Resources/ResourceDownloadList";
import Enquiry from "./Pages/Enquiry/Enquiry";
import Contact from "./Pages/Contact/Contact";
import Subscribe from "./Pages/Subscribe/Subscribe";
import News from "./Pages/News/News";
import Investors from "./Pages/Abouts/Investors";
import AdvisoryBoards from "./Pages/Abouts/AdvisoryBoards";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Authentication/Login";
import Register from './Pages/Authentication/Register';
import Users from './Pages/Users';
import Articles from './Pages/Articles';
import Hrglossary from './Pages/HrGlossary';
import Clients from './Pages/Abouts/Client';
import Certification from './Pages/Certification';
import Certification_bottom from './Pages/Certification/Bottom';
import CertificationEnquiry from './Pages/Certification-Enquiry/Certification-Enquiry';

function App() {
  const ABC = "abc"
  const[logged,setLogged] = useState(false)
  const timeNow = Math.floor(Date.now()/1000)
  useEffect(()=>{
    const getdata = JSON.parse(localStorage.getItem('Hrtech_token'))
    if(getdata){
      const tokenVal = JSON.parse(atob(getdata.split('.')[1]));
      
      if(tokenVal.exp>timeNow){
        setLogged(true)
      }else{
        setLogged(false)
        localStorage.clear();
        // history.push('/')
      }
    }
    else{
      setLogged(false)
      // history.push('/')
    }
  
  },[])
  return (
    <Router>
       {logged ? <>
       <Layout>
        <div className="dashboard-container">
          <div className="dashboard-body">
            <Routes>
              <Route path="*" element={<Blog />} />
		 <Route exact path="/certification" element={<Certification />} />
		 <Route exact path="/certification-bottom" element={<Certification_bottom />} />
		 <Route exact path="/articles" element={<Articles />} />
		<Route exact path="/hrglossary" element={<Hrglossary />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/category" element={<Category />} />
              <Route exact path="/subcategory" element={<Subcategory />} />
              <Route exact path="/division" element={<Division />} />
              <Route exact path="/marketplace" element={<MarketPlace />} />
              <Route exact path="/techtalks" element={<TechTalks />} />
              <Route exact path="/resources" element={<Resources />} />
              <Route exact path="/events" element={<Events />} />
              <Route exact path="/company" element={<Company />} />
              <Route exact path="/jobs" element={<Jobs />} />
              <Route exact path="/jobsapplied" element={<JobsApplied />} />
              <Route exact path="/navbar" element={<Navbar />} />
              <Route exact path="/abouts" element={<Abouts />} />
              <Route exact path="/banner" element={<Banner />} />
              <Route exact path="/certification-enquiry" element={<CertificationEnquiry />} />
	      <Route exact path="/marketplacereview" element={<Review />} />
              <Route exact path="/brochurelist" element={<BrochureList />} />
              <Route exact path="/resourcedownloadlist" element={<ResourceDownloadList />} />
              <Route exact path="/enquiry" element={<Enquiry />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/subscribe" element={<Subscribe />} />
              <Route exact path="/news" element={<News />} />
              <Route exact path="/investors" element={<Investors />} />
		 <Route exact path="/clients" element={<Clients />} />
              <Route exact path="/advisoryboards" element={<AdvisoryBoards />} />
              <Route exact path="/users" element={<Users />} />
               
            </Routes>
          </div>
        </div>
      </Layout>
       </>:<>
       <Routes>
       <Route path="*" element={<Login />} />
       <Route exact path="/login" element={<Login />} />
       <Route exact path="/register" element={<Register />} />
       </Routes></>}
      
    </Router>
  );
}
export default App;
